import React from 'react';

const DEFAULT_ICON_SIZE = { w: 125, h: 24 };

type Props = {
  w?: number;
  h?: number;
  className?: string;
};

const CryptoIcon = ({ className, w, h }: Props): JSX.Element => {
  return (
    <svg
      width={w || DEFAULT_ICON_SIZE.w}
      height={h || DEFAULT_ICON_SIZE.h}
      viewBox="0 0 125 24"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g fillRule="nonzero" fill="none">
        <path
          d="M10.396 0 0 6v12l10.396 6 10.396-6V6L10.396 0zm0 0L0 6v12l10.396 6 10.396-6V6L10.396 0z"
          fill="#FFF"
        />
        <path
          d="M14.5 19.313h-1.48l-1.77-1.625v-.834l1.833-1.75v-2.77l2.396-1.563 2.73 2.062-3.709 6.48zm-6.125-4.375.27-2.605L7.75 10h5.292l-.875 2.333.25 2.604H8.375zm1.208 2.75-1.77 1.645h-1.5l-3.73-6.5 2.75-2.041 2.417 1.541v2.771l1.833 1.75v.834zm-3.291-12.5h8.187l.98 4.166H5.332l.959-4.166zM10.396 0 0 6v12l10.396 6 10.396-6V6L10.396 0z"
          fill="#03316C"
        />
        <path
          d="M32.458 17.563c-2.75 0-4.77-2.146-4.77-4.792s2.041-4.854 4.791-4.854c1.75 0 2.834.646 3.688 1.583l-1.313 1.417c-.646-.688-1.333-1.146-2.396-1.146-1.541 0-2.666 1.333-2.666 2.958 0 1.667 1.145 3 2.77 3 1 0 1.73-.479 2.396-1.146l1.271 1.271c-.916.98-1.979 1.709-3.77 1.709M40.25 17.563h-2.125V7.938h2.125v2.25c.583-1.376 1.646-2.334 3.27-2.25v2.25h-.124c-1.854 0-3.146 1.208-3.146 3.666v3.709zM54.625 7.896l-4.688 12.25h-2.145l1.02-2.584-4.02-9.666h2.27l2.73 7.146 2.625-7.146zM60.875 9.75c-1.438 0-2.688 1.167-2.688 2.98 0 1.812 1.271 2.978 2.688 2.978 1.458 0 2.646-1.146 2.646-2.979 0-1.833-1.209-2.979-2.646-2.979m.48 7.792c-1.522 0-2.48-.771-3.126-1.625v4.229h-2.125V7.896h2.125v1.729c.688-.958 1.646-1.73 3.125-1.73 2.188 0 4.313 1.73 4.313 4.813 0 3.084-2.105 4.834-4.313 4.834M70.313 9.917v4.541c0 .813.416 1.146 1.145 1.146h.834V17.5h-1.459c-1.541 0-2.645-.688-2.645-2.708V9.917H67.02V8.104h1.166V5.563h2.126v2.541h1.979v1.813h-1.98zM78.98 9.75c-1.71 0-2.793 1.333-2.793 2.958 0 1.646 1.167 3 2.813 3 1.708 0 2.792-1.333 2.792-2.958.041-1.646-1.146-3-2.813-3m0 7.813c-2.812 0-4.896-2.146-4.896-4.792 0-2.667 2.105-4.854 4.938-4.854 2.833 0 4.916 2.146 4.916 4.812 0 2.625-2.083 4.834-4.958 4.834M104.208 9.75c-1.708 0-2.791 1.333-2.791 2.958 0 1.646 1.166 3 2.812 3 1.709 0 2.792-1.333 2.792-2.958.02-1.646-1.146-3-2.813-3m0 7.813c-2.812 0-4.895-2.146-4.895-4.792 0-2.667 2.104-4.854 4.937-4.854s4.917 2.146 4.917 4.812c0 2.625-2.105 4.834-4.959 4.834M121.75 7.896c2.02 0 3.25 1.27 3.25 3.542v6.104h-2.125v-5.459c0-1.479-.688-2.25-1.875-2.25-1.146 0-1.98.813-1.98 2.292v5.438h-2.124v-5.48c0-1.437-.709-2.25-1.875-2.25-1.167 0-1.98.875-1.98 2.313v5.416h-2.124V7.918h2.125V9.5c.604-.813 1.395-1.583 2.812-1.583 1.334 0 2.25.646 2.75 1.625.771-1 1.75-1.646 3.146-1.646M87.833 15.604v1.084l-.062.104-.938.52h-.125l-.916-.52-.063-.105v-1.083l.063-.104.916-.52h.125l.938.52zM94.27 17.542c-2.75-.063-4.728-2.25-4.687-4.896.042-2.646 2.125-4.813 4.896-4.75 1.75.042 2.834.708 3.667 1.667l-1.334 1.395c-.624-.687-1.312-1.187-2.374-1.208-1.542-.02-2.688 1.27-2.709 2.917-.041 1.666 1.084 3.02 2.709 3.041 1 .021 1.75-.437 2.416-1.104l1.25 1.292c-.937.979-2.02 1.687-3.833 1.646"
          fill="#002E73"
        />
      </g>
    </svg>
  );
};

CryptoIcon.ICON_SIZE = DEFAULT_ICON_SIZE;

export default CryptoIcon;
